module.exports = __webpack_public_path__ + "img/v1.3d2e0cd4.png";